import { forwardRef, useCallback } from 'react';
import { showAppNotification } from '@rainbow-modules/app';
import SendNoteForm from 'components/SendNoteForm';
import { MessageInputWrapper, DisabledOverlay, ReasonText } from './styled';
import getChannelAcceptedTypes from './helpers/getChannelAcceptedTypes';
import isFileSupportedByChannel from './helpers/isFileSupportedByChannel';

interface MessageInputProps {
    channel?: string;
    disabled?: boolean;
    isManychatApi?: boolean;
    reason?: string;
    onSend: (text: string, files: File[]) => Promise<void>;
}

const MessageInput = forwardRef(({
    channel,
    disabled = false,
    isManychatApi = false,
    reason = '',
    onSend,
}: MessageInputProps, ref) => {
    const isChannelSupported = ['facebook', 'instagram', 'whatsapp', 'tiktok', 'telegram'].includes(channel || '');

    const handleFilesRejected = useCallback((files: File[]) => {
        const message = (
            files.length > 1
                ? 'Some files are not supported by the channel'
                : 'One file is not supported by the channel'
        );
        showAppNotification({
            title: 'Error',
            description: message,
            icon: 'error',
            timeout: 5000,
        });
    }, []);

    if (!isChannelSupported) {
        return null;
    }

    const disableAttachFiles = isManychatApi && ['tiktok', 'whatsapp'].includes(channel as string);

    return (
        <MessageInputWrapper>
            <SendNoteForm
                ref={ref}
                placeholder="Type here..."
                mode="messages"
                disableSend={disabled}
                disableAttachments={disableAttachFiles}
                acceptedFormats={getChannelAcceptedTypes(channel || '', isManychatApi)}
                onSend={onSend}
                canAttachFile={isFileSupportedByChannel(channel || '', isManychatApi)}
                onFilesRejected={handleFilesRejected}
            />
            {disabled && (
                <DisabledOverlay>
                    <ReasonText>{reason}</ReasonText>
                </DisabledOverlay>
            )}
        </MessageInputWrapper>
    );
});

export default MessageInput;
